import config from 'constants/config'
import { PROVIDER_COVER_GENIUS } from 'constants/insurance'
import memoize from 'lib/memoize/memoize'
import moment from 'moment'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'

// isCoverGeniusEnables checks if the Cover Genius should be used for
// an insurance provider for the given region code.
export const isCoverGeniusEnabled = memoize((regionCode: string): boolean => {
  return isEnabledForFeature(config.COVER_GENIUS_COUNTRIES, regionCode)
})

export function isCoverGeniusEndDateValid(date: string):boolean {
  const dateIn1Year = moment().startOf('day').add(1, 'year')
  return !moment(date).isSameOrAfter(dateIn1Year)
}

export function isInternationalTripInsurable(date: string):boolean {
  const dateIn181Days = moment().startOf('day').add(181, 'days')
  return moment(date).isBefore(dateIn181Days)
}

export const getInsuranceProvider = (regionCode: string) => {
  if (isCoverGeniusEnabled(regionCode)) {
    return PROVIDER_COVER_GENIUS
  }

  return false
}

export const providerIsCoverGenius = (regionCode: string) => (getInsuranceProvider(regionCode) === PROVIDER_COVER_GENIUS)
